import { HelperText } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniHelperText = withUnistyles(HelperText)

export default UniHelperText
